import { createTheme } from "@mui/material";

declare module "@mui/material/Button" {
  interface ButtonPropsVariantOverrides {
    tr_button_cancel: true;
  }
}

export const trendratingCrmCustomTheme = createTheme({
  palette: {
    primary: {
      main: "#F2F2F2",
      dark: "#BFBFBF",
      contrastText: "#262626",
    },
    secondary: {
      main: "#0D0D0D",
    },
  },
  components: {
    MuiButton: {
      defaultProps: { variant: "contained", size: "small" },
      styleOverrides: {
        root: {
          textTransform: "none",
          minWidth: 0,
        },
      },
    },
    MuiCardContent: {
      defaultProps:{
        sx:{p:1}
      },
      styleOverrides: {
        root: {
          ":last-child": {
            p:1
          },
        },
      },
    },
  },
});
